
import { INVENTORY_ITEM_MENU_ITEM } from "@/consts";
import InventoryItemTable from "@/components/barcodeSystem/inventory/InventoryItemTable.vue";
import InventoryItemFilters from "@/components/barcodeSystem/inventory/InventoryItemFilters.vue";
import InventoryActions from "@/components/barcodeSystem/inventory/InventoryActions.vue";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import Component from "vue-class-component";
import permissions from "@/security/permissions";

const inventoryModuleState = getModule(InventoryModule);

@Component({
  components: {
    InventoryItemTable,
    InventoryActions,
    InventoryItemFilters
  }
})
export default class InventoryItems extends Vue {
  showInventoryItemFieldFilter: boolean = false;
  INVENTORY_ITEM_MENU_ITEM: any = INVENTORY_ITEM_MENU_ITEM;

  get itemFields() {
    return inventoryModuleState.itemFields;
  }

  async created() {
  }

  async loadMoreItems() {
    await inventoryModuleState.setLoading(true);
    await inventoryModuleState.getInventoryItems(null);
    await inventoryModuleState.setLoading(false);
  }

  async onSort(s) {
    await inventoryModuleState.setLoading(true);
    await inventoryModuleState.applyItemListSort(s);
    await inventoryModuleState.setLoading(false);
  }

  toggleChangeField(idx, hideShow) {
    inventoryModuleState.toggleItemField({ idx: idx, value: !hideShow });
  }

  get menuItemsToDisplay() {
    return this.INVENTORY_ITEM_MENU_ITEM.filter(
      x => (x.requiresPermission === undefined || this.hasPermission(x.requiresPermission)) && (x.requiresPermission != permissions.barcodeSystem.inventory.resolve || this.canResolve())
    );
  }

  canResolve(): boolean {
    return inventoryModuleState.getSelectedItemCount == 1 && inventoryModuleState.getSelectedItems[0].status == "M";
  }

  get dataRetreived() {
    if(inventoryModuleState.itemData)
      return true;
    return false;
  }
}


